import {lazy} from "react";
import Home from"../pages/Home";
import Gateways from"../pages/Gateways";
import Plans from"../pages/Plans";
import Users from"../pages/Users";
import GenericUserEditor from"../pages/GenericUserEditor";
import Communities from"../pages/Communities";
import Images from"../pages/Images";
import Administrators from"../pages/Administrators";
import Roles from"../pages/Roles";
import ServiceDomains from"../pages/ServiceDomains";
import PortalSettingsEditor from"../pages/EditorPages/PortalSettingsEditor";
import SystemSettingsEditor from"../pages/EditorPages/SystemSettingsEditor";
import Firmwares from"../pages/Firmwares";
import Servers from"../pages/Servers";
import GatewayLogs from"../pages/CyberViews/GatewayLogs";
import SystemLogsResults from"../pages/ResultsPages/SystemLogsResults";
import ActivityLogsResults from"../pages/ResultsPages/ActivityLogsResults";
import ServerGroups from"../pages/ServerGroups";
import InfectedHosts from "../pages/CyberViews/InfectedHosts";
import PreventedAttacks from "../pages/CyberViews/PreventedAttacks";
import DetectedAttacks from "../pages/CyberViews/DetectedAttacks";
import AttackTrends from "../pages/CyberViews/AttackTrends";
import SystemUsers from "../pages/SystemUsers";
import SystemRoles from "../pages/SystemRoles";
import Tools from "../pages/Tools";

// Lazy load for faster init time
export const GatewaysMap = lazy(() => import("../pages/GatewaysMap"));
const HELP_MODE_ONLINE = 0;

export const SMCPaths = {
    login: '/login',
    logout: '/logout',
    relogin: '/relogin',
    home: '/',
    root: '/',    
    map: '/map',
    gateways: '/gateways',
    plans: '/plans',
    users: '/users',
    systemUsers: '/system-users',
    genericUser: '/generic-user',
    communities: '/communities',
    portalSettings: '/portal-settings',
    systemSettings: '/system-settings',
    roles: '/roles',
    systemRoles: '/system-roles',
    images: '/images',
    administrators: '/administrators',
    firmwares: '/firmwares',
    serviceDomains: '/service-domains',
    servers: '/servers',
    serverGroups: '/server-groups',
    tools: '/tools',
    gatewayLogs: '/gateway-logs',
    systemLogs: '/system-logs',
    activityLogs: '/activity-logs',
    infectedHosts: '/infected-hosts',
    preventedAttacks: '/prevented-attacks',
    detectedAttacks: '/detected-attacks',
    attackTrends: '/attackTrends',
    infinityManage: '/infinity-manage',
    infinitySettings: '/infinity-settings'
}

export const routes = [{
        path: SMCPaths.home,
        component: Home,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.map,
        component: GatewaysMap,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.gateways,
        component: Gateways,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.plans,
        component: Plans,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.users,
        component: Users,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.systemUsers,
        component: SystemUsers,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.genericUser,
        component: GenericUserEditor,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.communities,
        component: Communities,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.portalSettings,
        component: PortalSettingsEditor,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.roles,
        component: Roles,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.systemRoles,
        component: SystemRoles,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.images,
        component: Images,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.systemSettings,
        component: SystemSettingsEditor,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.administrators,
        component: Administrators,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.firmwares,
        component: Firmwares,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.serviceDomains,
        component: ServiceDomains,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.servers,
        component: Servers,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.serverGroups,
        component: ServerGroups,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.tools,
        component: Tools,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.gatewayLogs,
        component: GatewayLogs,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.systemLogs,
        component: SystemLogsResults,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.activityLogs,
        component: ActivityLogsResults,
        showOnEmptyDomain: true
    }, {
        path: SMCPaths.infectedHosts,
        component: InfectedHosts,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.preventedAttacks,
        component: PreventedAttacks,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.detectedAttacks,
        component: DetectedAttacks,
        showOnEmptyDomain: false
    }, {
        path: SMCPaths.attackTrends,
        component: AttackTrends,
        showOnEmptyDomain: false
    }
]

export const infinityManageRoutes = [{
    path: SMCPaths.root,
    component: Gateways,
    showOnEmptyDomain: false
}, {
    path: SMCPaths.map,
    component: GatewaysMap,
    showOnEmptyDomain: false
}, {
    path: SMCPaths.gateways,
    component: Gateways,
    showOnEmptyDomain: false,
}, {
    path: SMCPaths.plans,
    component: Plans,
    showOnEmptyDomain: false,
}, {
    path: SMCPaths.users,
    component: Users,
    showOnEmptyDomain: false,
}, {
    path: SMCPaths.communities,
    component: Communities,
    showOnEmptyDomain: false
}
]

export const helpBaseUrl = "https://sc1.checkpoint.com/documents/SMP/Help/EN/Content/Topics/";

// Map translating help tags to offline or online value. ['offlineValue', 'onlineValue']
export const helpContextPageUrl = {
    general :                       ['Introduction-Help.htm'],
    default :                       ['Introduction-Help.htm'],
    maps :                          ['Showing-Gateway-Map-View.htm'],
    tools:                          ['Moving-SMP-Object-Settings-Data.htm'],
    attackTrends:                   ['Showing-Gateway-Logs-Firewall-Details.htm'],
    administratorsGeneral:          ['Editing-SMP-Administrators.htm'],
    administratorContact:           ['Configuring-SMP-Administrators-Contact-Details.htm'],
    administratorStatus:            ['Showing-SMP-Administrator-Status.htm'],
    administratorDomains:           ['Configuring-Service-Domains-Multi-Domain-Administrators.htm'],
    administratorExpiration:        ['Configuring-SMP-Administrator-Account-Expiration.htm'],    
    communityGeneral:               ['Configuring-Community-General-Settings.htm'],
    communityVPNSettings:           ['Configuring-Community-VPN-Settings.htm'],
    communityIKESettings:           ['Configuring-IKE-Settings.htm'],
    communityCustomFields:          ['Configuring-Community-VPN-Settings.htm'], 
    communityHistory:               ['Viewing-Community-Histories.htm'],
    gatewayGeneral:                 ['Configuring-General-Settings.htm'],    
    gatewayLocation:                ['Setting-Gateway-Location.htm'],        
    gatewayOwner:                   ['Configuring-Gateway-Owners.htm'],        
    gatewayStatus:                  ['Showing-Gateway-Status.htm'],            
    gatewayLogs:                    ['Showing-Gateway-Logs.htm'],
    gatewayNtp:                     ['NTP.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Device%20Settings%7C_____1'],    
    gatewayTimezone:                ['Time-Zone.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Device%20Settings%7C_____2'],        
    gatewayDns:                     ['DNS.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Device%20Settings%7C_____3'],            
    gatewayAdministrators:          ['Gateway-Administrators.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Device%20Settings%7C_____4'],
    gatewayLocalUsers:              ['Gateway-Administrators.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Device%20Settings%7C_____4'],
    gatewayFirewall:                ['Firewall.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____1'],
    gatewayAccessPolicy:            ['Access-Policy.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____2'],    
    gatewayApplicationsAndUrls:     ['Application-Control-URL-Filtering.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____2'],        
    gatewayIps:                     ['IPS.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____3'],
    gatewayTraditionalAntiVirus:    ['Traditional-Anti-Virus.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____4'],
    gatewayAntiSpam:                ['Anti-Spam.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____5'],    
    gatewayQos:                     ['QoS.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____6'],
    gatewayRemoteAccess:            ['Remote-Access.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____7'],
    gatewaySiteToSiteVpn:           ['Site-To-Site-VPN.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____8'],    
    gatewayUserAwareness:           ['User-Awareness.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____9'],
    gatewayAntiVirus:               ['Threat-Prevention-Anti-Virus.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____10'],    
    gatewayAntiBot:                 ['Threat-Prevention-Anti-Bot.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____11'],        
    gatewayThreatEmulation:         ['Threat-Prevention-Threat-Emulation.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____12'],            
    gatewayThreatPrevention:        ['Threat-Prevention-Policy.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____13'],
    gatewayThreatPreventionExceptions: ['Threat-Prevention-Policy.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____13'],
    gatewaySslInspection:           ['SSL-Inspection.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20Security%20Software%20Blades%7C_____14'],
    gatewayManagedServices:         ['Managed-Services.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CServices%7C_____1'],
    gatewayFirmware:                ['Firmware-Gateways-Plans.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CServices%7C_____2'],
    gatewayServiceBackup:           ['Periodic-Backup.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CServices%7C_____3'],    
    gatewayReports:                 ['Reports.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CServices%7C_____4'],        
    gatewayReportRecipients:        ['Report-Recipients.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CServices%7C_____5'],  
    gatewayNotifications:           ['Notifications.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CServices%7C_____6'],    
    gatewayNotificationRecipients:  ['Notifications-Recipients.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CServices%7C_____7'],
    gatewayDynamicDNS:              ['Dynamic-DNS.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CServices%7C_____8'],
    gatewayVpnCommunity:            ['VPN-Community-Settings.htm?tocpath=Home%7CShowing%20and%20Editing%20Gateways%7CConfiguring%20VPN%20Settings%20(Gateway)%7C_____1'],        
    planNtp:                        ['NTP.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Device%20Settings%7C_____1'],    
    planTimezone:                   ['Time-Zone.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Device%20Settings%7C_____2'],        
    planDns:                        ['DNS.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Device%20Settings%7C_____3'],            
    planAdministrators:             ['Gateway-Administrators.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Device%20Settings%7C_____4'],
    planLocalUsers:                 ['Gateway-Administrators.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Device%20Settings%7C_____4'],
    planFirewall:                   ['Firewall.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____1'],
    planAccessPolicy:               ['Access-Policy.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____2'],   
    planApplicationsAndUrls:        ['Application-Control-URL-Filtering.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____3'],        
    planIps:                        ['IPS.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____4'],
    planTraditionalAntiVirus:       ['Traditional-Anti-Virus.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____5'],
    planAntiSpam:                   ['Anti-Spam.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____6'],    
    planQos:                        ['QoS.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____7'],        
    planRemoteAccess:               ['Remote-Access.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____8'], 
    planSiteToSiteVpn:              ['Site-To-Site-VPN.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____9'],    
    planUserAwareness:              ['User-Awareness.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____10'],
    planAntiVirus:                  ['Threat-Prevention-Anti-Virus.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____11'],    
    planAntiBot:                    ['Threat-Prevention-Anti-Bot.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____12'],        
    planThreatEmulation:            ['Threat-Prevention-Threat-Emulation.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____13'],
    planThreatPrevention:           ['Threat-Prevention-Policy.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____14'],
    planThreatPreventionExceptions: ['Threat-Prevention-Policy.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____14'],
    planSslInspection:              ['SSL-Inspection.htm?tocpath=Home%7CEditing%20Plans%7CConfiguring%20Security%20Software%20Blades%7C_____15'],
    planManagedServices:            ['Managed-Services.htm?tocpath=Home%7CEditing%20Plans%7CServices%7C_____1'],
    planFirmware:                   ['Firmware-Gateways-Plans.htm?tocpath=Home%7CEditing%20Plans%7CServices%7C_____2'],
    planServiceBackup:              ['Periodic-Backup.htm?tocpath=Home%7CEditing%20Plans%7CServices%7C_____3'],    
    planReports:                    ['Reports.htm?tocpath=Home%7CEditing%20Plans%7CServices%7C_____4'],        
    planReportRecipients:           ['Report-Recipients.htm?tocpath=Home%7CEditing%20Plans%7CServices%7C_____5'],  
    planNotifications:              ['Notifications.htm?tocpath=Home%7CEditing%20Plans%7CServices%7C_____6'],    
    planNotificationRecipients:     ['Notifications-Recipients.htm?tocpath=Home%7CEditing%20Plans%7CServices%7C_____7'],
    planVpnCommunity:               ['VPN-Community-Settings.htm'],    
    vpnAuthenticationMethod:        ['Authentication-Method.htm'],
    vpnInternalNetworkTopology:     ['Configuring-Network-Topology-Gateways.htm'],    
    administratorAccess:            ['Administrators-Access.htm'],        
    gatewaysBehindNAT:              ['Gateway-Behind-NAT.htm'],
    cliScript:                      ['CLI-Script.htm'],
    hasCustomField:                 ['Editing-Custom-Fields-Gateways.htm'],
    imageGeneral:                   ['General-Settings-Custom-Image.htm'],    
    imageHistory:                   ['History-Custom-Images.htm'],        
    planGeneral:                    ['Configuring-General-Settings-Plan.htm'],
    planGatewayActivation:          ['Adding-Gateways.htm'],    
    planHistory:                    ['Showing-Plan-Histories.htm'],
    domainSettingsGeneral:          ['Configuring-General-Settings-Service-Domains.htm'],    
    domainSettingsLogging:          ['Configuring-Logging-Service-Domains.htm'],        
    domainSettingsDNS:              ['Configuring-DNS-Settings-Service-Domains.htm'],            
    domainSettingsCustomFields:     ['Configuring-Custom-Fields-Service-Domains.htm'],                
    domainSettingsMail:             ['Configuring-Outgoing-Mail-Settings-Service-Domains.htm'],                    
    domainSettingsFirmware:         ['Showing-Firmware-Service-Domains.htm'],
    domainSettingsGatewayNotifications:         ['Configuring-Gateway-Notifications.htm'],        
    domainSettingsGatewayReportsNotifications:  ['Configuring-Gateway-Report-Notification.htm'],
    domainSettingsUserNotifications:            ['Configuring-User-Notifications.htm'],
    domainSettingsSummaryMessagesNotifications: ['Configuring-Summary-Messages.htm'],    
    domainSettingsReportsNotifications:         ['Configuring-Summary-Reports-Service-Domains.htm'],        
    domainSettingsCustomAlerts:                 ['Using-Service-Domain-Custom-Alerts.htm'],
    domainNotifications:                        ['Configuring-Portal-Administrator-Notifications.htm'], 
    settingsTwoStepAuthentication:              ['Two-Step-Authentication.htm'],
    domainSettingsAPI:              ['REST-API-Access.htm'],
    roleGeneral:                    ['Configuring-Rules-Roles.htm'],
    roleAdvanced:                   ['Configuring-Advanced-Role-Settings.htm'],
    serverGeneral:                  ['Showing-General-Page-SMP-Servers.htm'],
    serverSettings:                 ['Configuring-Settings-SMP-Server.htm'],
    serverManagedModules:           ['Showing-Managed-Modules.htm'],
    serverGroupGeneral:             ['Showing-General-Page-SMP-Servers.htm'],
    serverGroupHistory:             ['Showing-SMP-Server-History.htm'],
    serverDomainGeneral:            ['Editing-General-Page.htm'],
    serverDomainHistory:            ['Showing-Service-Domain-Histories.htm'],
    systemSettingsGeneral:          ['Configuring-General-Settings-SMP.htm'],
    systemSettingsOverview:         ['Overview.htm'],
    systemSettingsHttpProxy:        ['Configuring-SMP-Portal-Use-Web-Proxy-Server.htm'],    
    systemSettingsMail:             ['Configuring-Outgoing-Mail-Settings-SMP.htm'],        
    systemSettingsLicenseManagement:            ['Showing-SMP-License.htm'],            
    systemSettingsSystemBackup:                 ['Configuring-SMP-Backup-Settings.htm'],                
    systemSettingsSystemBackupStatus:           ['Starting-SMP-Backup.htm'],    
    systemSettingsCertificateAuthority:         ['Configuring-SMP-Internal-Certificate-Authority.htm'], 
    systemSettingsNotificationsGeneral:         ['Configuring-System-Administrator-Notifications.htm'],        
    systemSettingsNotificationsReports:         ['Configuring-Service-Domain-Statistic-Reports.htm'],            
    systemSettingsCustomAlerts:                 ['Using-SMP-System-Custom-Alerts.htm'],                
    systemSettingsManagementAccessControl:      ['Configuring-Management-Access-Control.htm'],                    
    systemSettingsAdminAccessControl:           ['Configuring-Admin-Access-Control.htm'],
    systemSettingsLogging:                      ['Configuring-SMP-Logging.htm'],
    systemUserGeneral:              ['General-Settings-User.htm'],    
    systemUserExpiration:           ['Expiration-Settings-User.htm'],
    systemUserContact:              ['Contact-Settings-User.htm'],    
    showingUsers:                   ['Showing-Users.htm'],        
    systemUserStatus:               ['Status-Settings-User.htm'],            
    systemUserDomains:              ['Configuring-Service-Domains-Multi-Domain-Administrators.htm'],
    activityLogsResults:            ['Showing-Activity-Logs.htm'],
    administratorResults:           ['Showing-SMP-Administrators.htm'],
    communityResults:               ['Showing-Communities.htm'],
    firmwareResults:                ['Showing-Firmwares.htm'],
    gatewayResults:                 ['Showing-Editing-Gateways.htm'],
    imageResults:                   ['Uploading-Images-Email-Templates.htm'],
    planResults:                    ['Editing-Plans.htm'],
    roleResults:                    ['Showing-Roles.htm'],
    serverResults:                  ['Showing-Editing-SMP-Servers.htm'],
    serviceDomainResults:           ['Showing-Service-Domains.htm'],
    systemLogsResults:              ['Showing-System-Logs.htm'], 
    smpStatus:                      ['Showing-SMP-Status.htm'],  
    userSessions:                   ['Showing-Active-User-Sessions-Service-Domains.htm'],
    userCustomFields:               ['Custom-Fields-Settings-User.htm'],
}


export const getHelpURL = (pageId) => {
    return (helpBaseUrl + (pageId ? pageId[HELP_MODE_ONLINE] : helpContextPageUrl.default[HELP_MODE_ONLINE]));
}

